function Page404(){
return(
    <div className="container-404">
        <div>
            <img src="images/404.png"/>
            <h1>OOPS, Page Not Found</h1>
        </div>
    </div>
)
}

export default Page404